export enum USER_ROLE {
  ADMIN = 'Admin',
  MANAGER = 'Manager',
  WORKER = 'Worker',
  SITE_ADMIN = 'SiteAdmin',
  GUEST = 'Guest',
}
